import * as S from "../../styles";
import styled from "styled-components";

export const Card = styled(S.Card)`
  padding: 21px 19px 2px 20px;

  .accordionWrapper {
    margin: 24px 0;
  }

  .accordion {
    width: 100%;
  }

  p {
    font-size: 12px;
    font-family: Roboto;
    color: #747576;
  }

  .item {
    border-radius: 6px;
    border: solid 1px #b9b9ba;
    margin-bottom: 20px;
  }

  .title {
    color: #00a2e0;
    padding: 5px;
    margin: 0 5px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    align-items: center;
  }

  .title_show {
    color: #00a2e0;
    padding: 5px;
    margin: 0 0px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    align-items: center;
    border-radius: 6px 6px 0px 0px;
    background-color: #f6f6f6;
  }

  .content {
    font-size: 11px;
    font-family: Roboto;
    color: #747576;
    max-height: 0;
    overflow: hidden;
    margin: 0 5px;
    transition: all 0.5s cubic-bezier(0, 1, 0, 1);
  }

  .content_show {
    padding: 10px;
    margin: 0 5px;
    font-size: 11px;
    font-family: Roboto;
    color: #747576;
    height: auto;
    max-height: 999px;
    overflow: hidden;
    transition: all 0.5s cubic-bezier(1, 0, 1, 0);
  }
`;
